import { dropAllDatabases } from "@rocicorp/zero"
import { type QueryOptions, useQuery } from "@tanstack/react-query"
import * as Query from "./query.ts"
import { rpc } from "./rpc.ts"

export const queryOptions = {
  async queryFn(_context) {
    return await rpc.auth.data.$get().then((res) => res.json())
  },
  queryKey: ["auth_data"],
} as const satisfies QueryOptions

export function useAuthData(
  opts: { refetchOnMount?: "always" | boolean } = {},
) {
  return useQuery({ ...queryOptions, staleTime: 60_000, ...opts })
}

export async function logout() {
  await dropAllDatabases()
  await rpc.auth.logout.$post().catch(() => {})
  await Query.client.invalidateQueries({
    queryKey: queryOptions.queryKey,
  })
}

export function url(href?: string | undefined) {
  const url = rpc.auth.url.$url()
  if (href) url.searchParams.set("next", href)
  return url.toString()
}
